<template>
  <div>
  <div class="top">
    <div>首页</div>
    <div style="padding-left: 30px">登录</div>
  </div>
	<div class="hello" v-html="html">

	</div>
    <div style="background: #e8edf0;height: 80px;margin-top: 10px;display: flex;flex-direction: column;align-items: center;line-height: 30px;justify-content: center">
      <div>浙ICP备2025147938号</div>
      <div>浙ICP备2025147938号-4A</div>
    </div>
  </div>
</template>

<script>
	import axios from "axios";

  export default {
		name: 'HelloWorld',
data(){
      return{
        html:''
      }
},
    mounted() {
      axios({
        method: 'get',
        url: 'https://dev.zjlzhc.com//api/common/serve?type=yszc',
      }).then(res=>{
        this.html=res.data.data;
      })
    }
  }
</script>
<style>
.hello{
  width: 90%;
  border: 1px solid #eeeeee;
  padding: 20px;
  margin: 10px auto 0;
}

.top{
  height: 50px;
  background: #e8edf0;
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 20px;
  font-size: 18px;
}
</style>
